import { KeyRound } from "lucide-react";
import { useEffect, useState } from "react";
import { IdentityStatus } from "../components/IdentityShell.tsx";
import { auth, runOnce, safeOpsAuthorizationUrl } from "../lib/auth-client.ts";

export function Logout() {
  const [done, setDone] = useState(false);
  const continueTo = safeOpsAuthorizationUrl(
    new URLSearchParams(window.location.search).get("continue_to")
  );

  useEffect(() => {
    let active = true;
    void runOnce(`logout:${window.location.href}`, () => auth.signOut()).finally(() => {
      if (!active) return;
      if (continueTo) {
        window.location.replace(continueTo);
        return;
      }
      setDone(true);
    });
    return () => {
      active = false;
    };
  }, [continueTo]);

  if (!done) {
    return (
      <IdentityStatus
        title="正在退出登录"
        message="正在清除此浏览器中的 Matterline 会话…"
        step="登出"
        status="进行中"
      />
    );
  }

  return (
    <IdentityStatus
      title="已退出登录"
      message="此浏览器已清除 Matterline 会话。需要时请重新登录。"
      variant="success"
      step="登出"
      status="已完成"
      action={{
        label: "重新登录",
        icon: <KeyRound size={17} />,
        onClick: () => window.location.replace("/")
      }}
    />
  );
}
